// « beforeinstallprompt » peut être émis avant le montage de React : on l'intercepte dès le
// chargement du module et on le garde pour l'écran d'installation.

const INSTALLED_KEY = 'pwa-installed';

let deferredPrompt = null;
const subscribers = new Set();
const notify = () => subscribers.forEach(fn => fn());

const writeInstalled = value => {
  try {
    if (value) localStorage.setItem(INSTALLED_KEY, '1');
    else localStorage.removeItem(INSTALLED_KEY);
  } catch {
    /* stockage indisponible : on s'en remet à getInstalledRelatedApps */
  }
};

const readInstalled = () => {
  try {
    return localStorage.getItem(INSTALLED_KEY) === '1';
  } catch {
    return false;
  }
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    deferredPrompt = event;
    // Le navigateur ne propose l'installation que si l'appli n'est pas (ou plus) installée.
    writeInstalled(false);
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    writeInstalled(true);
    notify();
  });
}

export const canPromptInstall = () => deferredPrompt !== null;

export const subscribeInstallPrompt = fn => {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
};

// À appeler depuis un geste de l'utilisateur. Une invite ne sert qu'une fois.
export const promptInstall = async () => {
  const prompt = deferredPrompt;
  if (!prompt) return false;
  deferredPrompt = null;
  prompt.prompt();
  const {outcome} = await prompt.userChoice;
  notify();
  return outcome === 'accepted';
};

// Chrome Android sait dire si la PWA est installée (« related_applications » du manifest) ;
// ailleurs, on retient l'évènement « appinstalled » reçu dans ce navigateur.
export const isAppInstalled = async () => {
  if (navigator.getInstalledRelatedApps) {
    try {
      const apps = await navigator.getInstalledRelatedApps();
      if (apps.length > 0) return true;
    } catch {
      /* API refusée : on se rabat sur l'indicateur local */
    }
  }
  return readInstalled();
};
